export default __webpack_public_path__ + "static/media/NaplesToRome.724cb643.webp";